module.exports = __webpack_public_path__ + "img/serum-card-en.f4654bde.jpg";